<template>
  <b-modal id="forgot-password" title="Forgot Password" centered :hide-footer="true">
    <p class="text-success mb-0 mt-0" v-if="apiResponseMessage">Success! {{ apiResponseMessage }}</p>
    <b-form @submit.prevent="send">
      <b-form-group
        id="input-group-1"
        label="Email Address:"
        label-for="input-1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input id="input-1" v-model="form.email" type="email" required></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">
        Get Reset Password Link
        <b-spinner small v-if="isLoading"></b-spinner>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { forgotPassword } from "../../../../api/services/forgot-password";

export default {
  data() {
    return {
      form: {},
      isLoading: false,
      apiResponseMessage: ""
    };
  },
  methods: {
    async send() {
      this.isLoading = true;
      try {
        let { data, status } = await forgotPassword(this.form.email);
        status === 200 ? (this.apiResponseMessage = data.message) : "";
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style>
</style>